module.exports = __webpack_public_path__ + "static/img/4.0a3dcf0b.png";